/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_TestingInputs */

const en_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

const de_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

const fr_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

const es_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

const it_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

const nl_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

const pl_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

const fi_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

const da_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

const sv_portal_scanner_testing = /** @type {(inputs: Portal_Scanner_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing...`)
};

/**
* | output |
* | --- |
* | "Testing..." |
*
* @param {Portal_Scanner_TestingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_testing = /** @type {((inputs?: Portal_Scanner_TestingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_TestingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_testing(inputs)
	if (locale === "fr") return fr_portal_scanner_testing(inputs)
	if (locale === "es") return es_portal_scanner_testing(inputs)
	if (locale === "it") return it_portal_scanner_testing(inputs)
	if (locale === "nl") return nl_portal_scanner_testing(inputs)
	if (locale === "pl") return pl_portal_scanner_testing(inputs)
	if (locale === "fi") return fi_portal_scanner_testing(inputs)
	if (locale === "da") return da_portal_scanner_testing(inputs)
	if (locale === "sv") return sv_portal_scanner_testing(inputs)
	return en_portal_scanner_testing(inputs)
});